if (!customElements.get('starter-kit-multi-widget')) {
  customElements.define(
    'starter-kit-multi-widget',
    class StarterKitMultiWidget extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.slider = this.querySelector('advanced-slider');
        this.swiper = this.querySelector('advanced-slider').swiper;
        this.sectionId = this.getAttribute('id');
        this.switchers = this.querySelectorAll('.starter-kit-multi-widget__switcher button');

        this.initSwitchers();
        this.initSlider();
      }

      initSlider() {
        const handleSlideChange = () => {
          const currentSlide = this.swiper.slides[this.swiper.activeIndex];
          const type = currentSlide.getAttribute('data-type');

          if (type) {
            const relatedSwitcher = Array.from(this.switchers).find(switcher => switcher.getAttribute('data-type') === type);

            // Check if the switcher is already active
            if (!relatedSwitcher.classList.contains('active')) {
              relatedSwitcher.classList.add('active');
              relatedSwitcher.click();
            }
          }
        };

        this.slider.addEventListener('advanced-slider:slide-change', debounce(handleSlideChange.bind(this), 200));
      }

      initSwitchers() {
        this.switchers.forEach(switcher => {
          switcher.addEventListener('click', () => this.handleSwitcherClick(switcher));
        });
      }

      handleSwitcherClick(switcher) {
        const type = switcher.getAttribute('data-type');

        // Handle switcher buttons
        const switcherButtons = this.querySelectorAll('.starter-kit-multi-widget__switcher button');
        switcherButtons.forEach(button => {
          const buttonType = button.getAttribute('data-type');
          if (buttonType === type) {
            button.classList.replace('btn--secondary', 'btn--primary');
          } else {
            button.classList.replace('btn--primary', 'btn--secondary');
          }
        });

        // Handle reviews and included items show/hide
        const containers = this.querySelectorAll('.yotpo-review-container, .included-items-container');
        containers.forEach(container => {
          const containerType = container.getAttribute('data-product-type');
          container.style.display = containerType === type ? 'block' : 'none';
        });

        // Find the slide index that matches the switcher's data-type
        const targetSlideIndex = Array.from(this.swiper.slides).findIndex(slide => slide.getAttribute('data-type') === type);

        if (targetSlideIndex !== -1) {
          this.swiper.slideTo(targetSlideIndex); // Navigate to the target slide
        }

        if (switcher.classList.contains('active')) {
          switcher.classList.remove('active')
          fetch(`${window.location.pathname}?sections=${this.sectionId}&type=${type}&view=${Date.now()}`)
            .then(res => res.json())
            .then(data => {
              const html = new DOMParser().parseFromString(Object.values(data)[0], 'text/html');

              const newElements = html.querySelectorAll('[data-context]');

              newElements.forEach(newElement => {
                const context = newElement.getAttribute('data-context');
                const currentElement = this.querySelector(`[data-context="${context}"]`);

                if (currentElement && !['reviews', 'switcher', 'included-items'].includes(context)) {
                  currentElement.replaceWith(newElement);
                }
              });

              this.switchers = this.querySelectorAll('[data-context="switcher"] button');
              this.initSwitchers();
          });
        }
      }
    }
  );
}